/**
 * THIRD Space: バリアント(カラー等)選択時に、対応する画像へサーバー通信
 * なしで即座にジャンプする。
 *
 * 全カラー分の画像はページ読み込み時点で既にDOM上に存在している
 * (snippets/product-media-gallery-content.liquidのsorted_media =
 * selected_product.media。選択中のバリアントの画像を先頭に並べ替えている
 * だけで、他の画像も消さずに全部レンダリングしている)。そのため、
 * サーバーから新しいHTMLを取得しなくても、既存のスライドの中から該当する
 * 画像を探して表示を切り替えるだけで即座に反映できる。
 *
 * 画像IDはスウォッチ入力のdata-option-media-id(そのオプション値の代表
 * 画像)を使う。商品ページ本体の入力は商品カード用のsnippets/
 * variant-swatches.liquidではなくsnippets/variant-main-picker.liquidで
 * 描画されており、当初はそちらにこの属性が無かったため動作していなかった
 * (2026-10-18に属性を追加して修正)。スライド側はsnippets/product-media.
 * liquidでdata-media-idが付与されている。
 *
 * 価格・在庫・SKU表示は、別の複数のコンポーネント(product-price.js等)が
 * サーバーから取得したHTML断片をそのまま差し込む作りになっており、ここで
 * 安全に再現できないため、既存のサーバー同期(assets/variant-picker.jsの
 * fetch)にそのまま任せる。少し遅れてそのfetchが完了し画像ギャラリーが
 * 丸ごと入れ替わるが、入れ替わった後も(並べ替え済みの)同じ画像が先頭に
 * 来るだけなので、見た目が変わって見えることはない。
 *
 * assets/variant-picker.js自体は変更せず、同じchangeイベントに相乗りする
 * だけの独立したリスナーなので、既存の動作に影響を与えない。
 */
document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  const picker = target.closest('variant-picker');
  if (!picker) return;

  const selectedOption =
    target instanceof HTMLSelectElement ? target.options[target.selectedIndex] : target;
  const mediaId = selectedOption?.dataset?.optionMediaId;
  if (!mediaId) return;

  const scope = picker.closest('.shopify-section, dialog');
  const mediaGallery = /** @type {{ slideshow?: { select: (index: number, event?: Event, options?: { animate?: boolean }) => void } } & Element | null} */ (
    scope?.querySelector('media-gallery')
  );
  const slideshow = mediaGallery?.slideshow;
  if (!mediaGallery || !slideshow) return;

  const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide'));
  const index = slides.findIndex((slide) => slide.querySelector(`[data-media-id="${mediaId}"]`));
  if (index === -1) return;

  slideshow.select(index, undefined, { animate: false });
});
